<template>

    <a-spin :spinning="loading">
        <div class="main">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Finances</h3>
                <!-- <div>
                    <a-range-picker
                    :default-value="[moment(startDate, dateFormat), moment(endDate, dateFormat)]"
                    :format="dateFormat"
                    @change="onChange"
                    />
                </div> -->
            </div>
            <div>
                <a-row>
                    <a-col style="background:#9bbd9f;border-radius:8px;height:310px" :span="15">
                        <a-row style="padding-top:60px" type="flex" justify="center" align="middle">
                            <a-col :span="10">
                                <div style="font-size:18px;color:#ffffff">Pending Payment:</div>
                                <div style="padding-top:20px;font-size:30px;color:#fff">Ksh {{
        financeOverview.monthlyRevenue.toLocaleString(undefined, { minimumFractionDigits: 2 })
    }}</div>
                            </a-col>
                            <a-col :span="10">
                                <div style="font-size:18px;color:#ffffff">Payout Due:</div>
                                <div style="padding-top:20px;font-size:30px;color:#fff">Ksh {{
        financeOverview.payoutDue.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                </div>

                            </a-col>
                            <div style="margin-top:30px;margin-left:160px;margin-bottom:30px">
                                <a-button @click="showAllRequestModal()"
                                    style="height:38px;cursor:pointer; border-raduis:5px;outline:none; background: #418a49;border: none; color:#fff;">
                                    Request for Payment
                                </a-button>

                                <finance-action ref="requestAll" :data="{}" :msg="allPendingMsg"
                                    :payout_amount="payout_amount" @clicked="confirmAll"></finance-action>
                            </div>
                        </a-row>
                    </a-col>
                    <a-col style="background:#fff;border-radius:8px;height:310px" :span="8" :offset="1">
                        <div style="padding:20px;">
                            <div style="display:flex;justify-content:space-between">
                                <div style="font-size:18px">Your Bank Details:</div>
                                <div>
                                    <div @click="showBankDetailsModal"
                                        style="color:#40a9ff; font-size:14px;cursor:pointer">
                                        Edit <span><a-icon type="edit" theme="filled"></a-icon></span>
                                    </div>
                                </div>
                            </div>

                            <small style="color:#4d4f5c">NB: All payment requests will be sent to the bank details
                                below</small>
                            <a-row style="padding-top:10px;color:#a4afb7">
                                <a-col :span="10">Account Name:</a-col>
                                <a-col :span="10">{{ bankDetails.accountName }}</a-col>
                            </a-row>
                            <a-row style="padding-top:10px;color:#a4afb7">
                                <a-col :span="10">Bank:</a-col>
                                <a-col :span="10">{{ bankDetails.bankName }}</a-col>
                            </a-row>
                            <a-row style="padding-top:10px;color:#a4afb7">
                                <a-col :span="10">Branch:</a-col>
                                <a-col :span="10">{{ bankDetails.branch }}</a-col>
                            </a-row>
                            <a-row style="padding-top:10px;color:#a4afb7">
                                <a-col :span="10">Acc. Number:</a-col>
                                <a-col :span="10">{{ bankDetails.accountNumber }}</a-col>
                            </a-row>
                            <a-row style="padding-top:10px;color:#a4afb7">
                                <a-col :span="10">Status:</a-col>
                                <a-col :span="10">{{ bankDetails.status === 1 ? 'Confrimed' : 'Pending Review'
                                    }}</a-col>
                            </a-row>
                        </div>

                    </a-col>
                </a-row>

            </div>
            <div style="margin-top:63px;margin-bottom: 30px">
                <!-- <div>
                    <p>Payout Checkout</p>
                    <a-table
                    :columns="columns"
                    :data-source="tableData"
                    :pagination="{ pageSize: 10 }"
                    class="financeTable"
                    >
                        <template slot="status" slot-scope='data'>
                        
                            <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="data === 0">
                                <p style="font-size:12px;color:#ffb102;"> Pending </p>
                            </div>
                            <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="data === 1">

                                <p style="font-size:12px;color:rgb(23 140 20);"> Paid </p>
                            </div>
                        
                        </template>
<template slot="action" slot-scope='data'>
                            <a-dropdown>
                                <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                    <a-icon style="font-size:25px;" type="ellipsis" />
                                </a>
                                <a-menu slot="overlay">
                                    <a-menu-item>
                                        <div v-show="data.status === 1">
                                            <a style="color:#007bff" @click="showRequestModal(data.id)" v-show="data.status === 1">Raise A Dispute</a>
                                            <finance-action :ref="data.id" :data="data" :msg="disputeMsg" @clicked="confirm"></finance-action>
                                        </div>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a style="color:#007bff" >View Details</a>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                            
                            
                        </template>

</a-table>
</div> -->
                <div>
                    <div class="actions">
                        <p>Payout Transaction History</p>
                        <a-button :loading="exportLoading" @click="exportExcell"
                            style="height:31px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                            icon="export">
                            Export
                        </a-button>
                    </div>

                    <a-table :columns="financeHistoryColumns" :data-source="financeHistoryData"
                        :pagination="{ pageSize: 20 }" class="financeTable">
                    </a-table>
                </div>
            </div>
            <a-modal class="modalStyle" :visible="addBankDetailsVisible" :footer="null"
                @cancel="handleAddBankDetailsCancel">
                <div style="display:flex;justify-content: center;">
                    <img class="img_size" src="../../assets/img/bank.png" />
                </div>
                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Bank Details</p>
                <div>
                    <a-form-model ref="addBankDetailsForm" :model="addBankDetailsModel" :rules="rules">
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Account Name" ref="accountName" prop="accountName">
                                    <a-input class="" v-model="addBankDetailsModel.accountName" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Bank Name" ref="bankName" prop="bankName">
                                    <a-input class="" v-model="addBankDetailsModel.bankName" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Branch Name" ref="branch" prop="branch">
                                    <a-input class="" v-model="addBankDetailsModel.branch" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="10" :offset="1">
                                <a-form-model-item label="Account Number" ref="accountNumber" prop="accountNumber">
                                    <a-input class="" v-model="addBankDetailsModel.accountNumber" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>


                        <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                            <a-spin class="spinner" :spinning="addBankloading" />
                        </div>

                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
                            <a-button @click="handleBankDetails"
                                style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                                Save
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
        </div>
    </a-spin>

</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import XLSX from "xlsx";
import FinanceAction from './common/FinanceAction'

const columns = [
    {
        title: 'Payment ID',
        // width: 150,
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: 'Description',
        dataIndex: 'description',
        // width: 130,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        //  width: 50,
    },
    {
        title: 'PayoutDue',
        dataIndex: 'payoutDue',
        // width: 150,
    },
    {
        title: 'Commission Paid',
        dataIndex: 'commissionPaid',
        // width: 150,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' },
        //  width: 50,
    },
    //   {
    //     title: 'Created At',
    //     dataIndex: 'createdAt',
    //     // width: 150,
    //   },
    {
        title: 'Action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
        //  width: 50,
    },

];

const financeHistoryColumns = [
    {
        title: 'Amount Paid',
        dataIndex: 'amountPaid',
        // width: 150,
    },
    {
        title: 'Date Paid',
        dataIndex: 'datePaid',
        // width: 150,
    },
]

const data = [
    {
        key: 1,
        id: 1,
        description: "Description 1",
        amount: 200,
        payoutDue: moment().subtract(4, 'day'),
        commissionPaid: 3,
        status: 0,
        createdAt: moment().subtract(4, 'day'),
        action: {}

    },
    {
        key: 2,
        id: 2,
        description: "Description 2",
        amount: 400,
        payoutDue: moment().subtract(6, 'day'),
        commissionPaid: 4,
        status: 1,
        createdAt: moment().subtract(6, 'day'),
        action: {}

    },
    {
        key: 3,
        id: 3,
        description: "Description 3",
        amount: 200,
        payoutDue: moment().subtract(1, 'day'),
        commissionPaid: 3,
        status: 0,
        createdAt: moment().subtract(1, 'day'),
        action: {}

    }
]


export default {
    name: "Finances",
    components: {
        FinanceAction
    },
    data() {
        return {
            columns,
            financeHistoryColumns,
            data,
            tableData: [],
            financeHistoryData: [],
            addBankDetailsVisible: false,
            addBankloading: false,
            dateFormat: 'YYYY-MM-DD',
            startDate: moment().subtract(30, 'd').format('YYYY-MM-DD'),
            endDate: moment().add(1, 'd').format('YYYY-MM-DD'),
            hasBankDetails: false,
            showRequest: false,
            loading: false,
            financeOverview: {
                monthlyRevenue: 0,
                payoutDue: 0
            },
            exportLoading: false,
            bankDetails: {
                accountName: '',
                bankName: '',
                branch: '',
                accountNumber: '',
                status: ''
            },
            addBankDetailsModel: {
                accountName: '',
                branch: '',
                bankName: '',
                accountNumber: ''
            },
            pendingMsg: "Make a payment request for this month?",
            allPendingMsg: "Withdraw all pending payment?",
            disputeMsg: "Make a request for a dispute?",

            rules: {
                accountName: [
                    { required: true, message: 'Please enter account name', trigger: 'change' },
                ],
                bankName: [
                    { required: true, message: 'Please enter bank name', trigger: 'change' }
                ],
                branch: [
                    { required: true, message: 'Please enter branch name', trigger: 'change' }
                ],
                accountNumber: [
                    { required: true, message: 'Please enter account number', trigger: 'change' }
                ],
            },
        };
    },
    computed: {
        payout_amount() {
            return `Ksh ${this.financeOverview.payoutDue.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
        }
    },

    methods: {
        ...mapActions(['getClientBankDetail', 'updateClientBankDetail', 'createClientBankDetail', 'getFinancesData', 'financeRequest']),
        moment,
        onChange(date, dateString) {
            // console.log(date, dateString);
            this.startDate = dateString[0];
            this.endDate = dateString[1];

            let request_data = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            this.loadFinancesData(request_data)
        },
        async loadBankDetailsData() {
            let response = await this.getClientBankDetail();
            this.displayBankDetails(response)
        },

        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },

        exportExcell() {

            this.exportLoading = true
            const dataToExport = [
                [
                    "Amount Paid",
                    "Date Paid"
                ],
            ];

            this.exportLoading = false;

            this.financeHistoryData.forEach((v) => {
                dataToExport.push([
                    v.amountPaid,
                    v.datePaid
                ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Payout-Transaction-History-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")
        },

        displayBankDetails(bankDetails) {
            // console.log("bankDetails | " ,bankDetails);
            if (bankDetails.status === 200) {
                this.hasBankDetails = true;
                this.bankDetails = {
                    accountName: bankDetails.data.accountName,
                    bankName: bankDetails.data.bankName,
                    branch: bankDetails.data.branch,
                    accountNumber: bankDetails.data.accountNumber,
                    status: bankDetails.data.status
                }
                this.addBankDetailsModel = {
                    accountName: bankDetails.data.accountName,
                    bankName: bankDetails.data.bankName,
                    branch: bankDetails.data.branch,
                    accountNumber: bankDetails.data.accountNumber,
                    status: bankDetails.data.status
                }
            } else if (bankDetails.status === 404) {
                this.hasBankDetails = false;
                this.bankDetails = {
                    accountName: "N/A",
                    bankName: "N/A",
                    branch: 'N/A',
                    accountNumber: "N/A",
                    status: "N/A"
                }
                this.addBankDetailsModel = {
                    accountName: '',
                    bankName: '',
                    branch: '',
                    accountNumber: '',
                    status: ''
                }

            } else {
                this.bankDetails = {
                    accountName: "N/A",
                    bankName: "N/A",
                    branch: "N/A",
                    accountNumber: "N/A",
                    status: "N/A"
                }
            }
        },

        handleAddBankDetailsCancel() {
            this.addBankDetailsVisible = false;
        },

        showBankDetailsModal() {
            this.addBankDetailsVisible = true;
        },

        handleBankDetails() {
            this.$refs.addBankDetailsForm.validate(valid => {
                if (valid) {
                    // console.log("hasBankDetails | ", this.hasBankDetails)
                    if (this.hasBankDetails) {
                        this.updateBankDetails()
                    } else {
                        this.createBankDetails()
                    }
                } else {
                    return false
                }
            });
        },

        async updateBankDetails() {
            this.addBankloading = true;

            let request_data = {
                accountName: this.addBankDetailsModel.accountName,
                bankName: this.addBankDetailsModel.bankName,
                branch: this.addBankDetailsModel.branch,
                accountNumber: this.addBankDetailsModel.accountNumber
            }

            const response = await this.updateClientBankDetail(request_data)
            if (response.status === 200) {
                this.addBankloading = false;
                this.addBankDetailsVisible = false;
                this.bankDetails = {
                    accountName: response.data.accountName,
                    bankName: response.data.bankName,
                    branch: response.data.branch,
                    accountNumber: response.data.accountNumber,
                    status: response.data.status
                }
                this.showSuccessAlert("Bank Details Updated Successfully");
            } else {
                this.addBankloading = false;

                this.showErrorAlert("Something went wrong, try again later")
                // console.log("Error | ", response)
            }
        },

        async createBankDetails() {
            this.addBankloading = true;

            let request_data = {
                accountName: this.addBankDetailsModel.accountName,
                bankName: this.addBankDetailsModel.bankName,
                branch: this.addBankDetailsModel.branch,
                accountNumber: this.addBankDetailsModel.accountNumber
            }

            const response = await this.createClientBankDetail(request_data)
            if (response.status === 200) {
                this.addBankloading = false;
                this.addBankDetailsVisible = false;
                this.bankDetails = {
                    accountName: response.data.accountName,
                    bankName: response.data.bankName,
                    branch: response.data.branch,
                    accountNumber: response.data.accountNumber,
                    status: response.data.status
                }
                this.showSuccessAlert("Bank Details Updated Successfully");
            } else {
                this.addBankloading = false;
                this.showErrorAlert("Something went wrong, try again later")
                // console.log("Error | ", response)
            }
        },

        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        async loadFinancesData(request_data) {
            this.loading = true
            let response = await this.getFinancesData(request_data)
            this.loading = false
            this.getMonthlySales(response[0]);
            this.financeOverview = response[1].data;
            this.payoutHistory(response[2])
        },
        payoutHistory(response) {

            if (response.status === 200) {
                this.financeHistoryData = response.data.data.map(finance => ({
                    key: this.randomString(10),
                    id: finance.id,
                    amountPaid: finance.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                    datePaid: moment(finance.paidAt).format("DD-MMM-YYYY"),
                    action: finance
                }))
            } else {
                // console.log("Error | ", response)
            }
        },
        getMonthlySales(response) {

            if (response.status === 200) {
                this.tableData = response.data.data.map(finance => ({
                    key: this.randomString(10),
                    id: finance.id,
                    description: finance.description,
                    amount: finance.amount.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                    payoutDue: finance.payoutDue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                    commissionPaid: finance.commissionPaid.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                    status: finance.status,
                    createdAt: moment(finance.createdAt).format("DD-MMM-YYYY"),
                    action: finance
                }))
            } else {
                // console.log("Error | ", response)
            }
        },
        showRequestModal(id) {
            this.$refs[id].setVisible(true)
        },
        showAllRequestModal() {
            this.$refs.requestAll.setVisible(true)
        },
        async confirm(value) {
            // console.log(" value | ", value)
            this.$refs[value.id].setVisible(false)
            this.loading = true
            if (value) {
                let status = value.status === 0 ? 1 : 1
                let request_data = {
                    status: status
                }
                // console.log(" request_data | ", request_data)
                let response = await this.financeRequest(request_data)
                if (response.status === 200) {
                    this.loading = false
                    this.showSuccessAlert("Request Made Successfully ")
                } else {
                    this.loading = false
                    this.showErrorAlert("Something went wrong, try again later")
                    // console.log("Error | ", response)
                }
            }
        },
        confirmAll() {
            this.$refs.requestAll.setVisible(false)
            this.loading = true
            let pendingPayment = this.tableData.filter(product => product.status === 0)
            pendingPayment.forEach(() => {
                let request_data = {
                    status: 1
                }
                this.financeRequest(request_data)
            })
            this.loading = false
            this.showSuccessAlert("Request Made Successfully ")
        }
    },
    created() {
        if (this.loadBankDetailsData) {
            this.loadBankDetailsData()
        }

        if (this.loadFinancesData) {
            let request_data = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            this.loadFinancesData(request_data)
        }
    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.img_size {
    max-width: 56px;
    max-height: 55px;
}

.financeTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.financeTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.financeTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.financeTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.center-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
    font-size: 40px;
}
</style>